import useLocationGuestAiSummary from './useLocationGuestAiSummary'

export const api = {
  fwWingstopLocationGuestAiSummary: useLocationGuestAiSummary,
}
